import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect slug cũ /i-ching-detail → /kinh-dich-chi-tiet (giữ backlink/SEO).
export const Route = createFileRoute("/i-ching-detail")({
  beforeLoad: () => {
    throw redirect({ to: "/kinh-dich-chi-tiet", replace: true });
  },
  component: () => null,
});
